import { postCall } from "../../networking";
import { catalogueUrls } from "../../networking/url";

export const createSalesOrder = (data) => async (dispatch) => {
    try {
        const response = await postCall(catalogueUrls.createOrder, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const updateSalesOrder = (data) => async (dispatch) => {
    try {
        const response = await postCall(catalogueUrls.updateSalesOrder, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
                statusCode: response.data?.statusCode,
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};

export const checkoutSalesOrder = (data) => async (dispatch) => {
    try {
        const response = await postCall(catalogueUrls.checkoutOrder, data);
        if (response.data?.isSuccessful) {
            return {
                status: true,
                message: response.data?.message,
                data: response.data?.data,
            };
        } else {
            return {
                status: false,
                message: response.data?.message || "Sorry, an error occurred. Please try again",
            };
        }
    } catch (error) {
        return {
            status: false,
            message: "Sorry, an error occurred. Please try again",
        };
    }
};
